"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maps = void 0;
var axios_1 = __importDefault(require("axios"));
exports.maps = {
    getGeocodeList: function (address, language) { return axios_1.default.get('https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyB2r8MstzOL8RZk8RhEWbBcszH2sAZ3LRU', { params: { address: address, language: language } }).then(function (res) { return res.data.results; }); },
};
